import {Drawable} from "./Drawable";

const ZOOMS = [0.125, 0.25, 0.5, 0.75, 1, 1.5, 2, 3, 4, 6, 8];
export class Canvas {

	/**
	 * @param {CanvasEditor} editor
	 */
	constructor(editor) {
		this.editor = editor;

		this.zoomIdx = 4;
		this.scrollX = 40;
		this.scrollY = 64; // plus toolbar height
	}

	get zoom() {
		return ZOOMS[this.zoomIdx];
	}

	draw(ctx, currentTool) {
		ctx.save();
		ctx.translate(this.scrollX, this.scrollY);
		ctx.scale(this.zoom, this.zoom);
		this.drawBackground(ctx, currentTool);
		this.drawBeforeModel(ctx, currentTool);
		this.drawModel(ctx, currentTool);
		this.drawAfterModel(ctx, currentTool);
		ctx.restore();
	}


	drawBackground(ctx, currentTool) {
	}

	drawModel(ctx, currentTool) {
	}

	drawBeforeModel(ctx, currentTool) {
	}

	drawAfterModel(ctx, currentTool) {
	}

	/**
	 * @return {array} of object editors, which will be displayed on the canvas in order of appearance
	 */
	getManipulables() {
		return [];
	}

	zoomIn() {
		this.zoomIdx++;
		if (this.zoomIdx >= ZOOMS.length) this.zoomIdx = ZOOMS.length - 1;
	}

	zoomOut() {
		this.zoomIdx--;
		if (this.zoomIdx < 0) this.zoomIdx = 0;
	}

	/**
	 * Delete selected items
	 * @param {KeyboardEvent} e
	 */
	delete(e) {
	}
}